export enum PfcSensorOptionsEnum {
  POTENTIAL_FREE_CONTACT = 'POTENTIAL_FREE_CONTACT_'
}
